import { useI18n } from 'vue-i18n'

import useBlProviders from '@/composables/providers/useBlProvider'
import InfrastructureTagsDt from '@/services/dataTransferModules/infrastructureTagsDt'

const infrastructureTagsDt = new InfrastructureTagsDt()

export default function useInfrastructureTags() {
	const { t: $t } = useI18n()

	const {
		loadEntityFlags: flags,

		entities: infrastructureTags,
		getEntities: getInfrastructureTags,

		entityPreview: infrastructureTagsPreview,
		getEntityPreview: getInfrastructureTagsPreview,

		entity: infrastructureTag,
		getEntity: getInfrastructureTag,

		createEntity: createInfrastructureTags,
		patchEntity: updateInfrastructureTags,
		updateEntity: fullUpdateInfrastructureTags,
		deleteEntity: deleteInfrastructureTags,
	} = useBlProviders(infrastructureTagsDt, {
		showErrorNotificationForLoadingAllEntities: true,
		errorNotificationTextForLoadingAllEntities: $t('Infrastructure tag loading error'),

		showErrorNotificationForLoadingOneEntity: true,

		showErrorNotificationForCreatingEntity: true,
		errorNotificationTextForCreatingEntity: $t('It was not possible to add a new infrastructure tags. Contact those support.'),

		showErrorNotificationForUpdatingEntity: true,
		errorNotificationTextForUpdatingEntity: $t('It was not possible to edit a infrastructure tags. Contact those support.'),

		showErrorNotificationForDeletingEntity: true,
	})

	const defaults = {
		creatingInfrastructureTag: {
			name: '',
		},
		fieldsToPatch: ['name'],
	}

	return {
		flags,
		infrastructureTags,
		infrastructureTagsPreview,
		infrastructureTag,
		defaults,
		getInfrastructureTags,
		getInfrastructureTagsPreview,
		getInfrastructureTag,
		createInfrastructureTags,
		deleteInfrastructureTags,
		updateInfrastructureTags,
		fullUpdateInfrastructureTags,
	}
}
